import { createAsyncThunk } from "@reduxjs/toolkit";
export const baseUrl = localStorage.getItem('baseUrl');;

//Login
export const loginUser = createAsyncThunk('/login', async (postData) => {
     const res = await fetch(`${baseUrl}/login`, {
        method:"POST",
        body: JSON.stringify({email: postData.email, password: postData.password, userType:postData.userType})
     });
     const result = await res.json();
     return result;
});

//getAlerts
export const getAlerts = createAsyncThunk(`/getAlerts`, async (data={}) => {
    const res = await fetch(`${baseUrl}/users?isAlert=${data.isAlert}`,{
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
     });
    const result = await res.json();
    return result;
});

//Users
export const getUsers = createAsyncThunk(`/users`, async () => {
    const res = await fetch(`${baseUrl}/users`, {
        method:"GET",
        headers:{
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        }
    });
    
    const result = await res.json();
    return result;
});

// delete User
export const deleteUser = createAsyncThunk(`/user/delete`, async (userId) => {
    const res = await fetch(`${baseUrl}/user/delete`,{
        method:"POST",
        headers:{
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({userId})
    });
    
    const result = await res.json();
    return result;
});


//getUser single
export const getUser = createAsyncThunk(`/getUser`, async (userId) => {

    const res = await fetch(`${baseUrl}/user?userId=${userId}`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
     });

    const result = await res.json();
    return result;
});
//searchUsers
export const searchUsers = createAsyncThunk(`/user/searchUsers`, async (filters={}) => {
    let isFilter= false;
    let url = `${baseUrl}/users`;
    let params = '';

    if(Object.keys(filters).length > 0){
        isFilter = true;
        if(filters.firstName){
            params= params.concat(`firstName=${filters.firstName}&`);
        }
        if(filters.lastName){
            params=params.concat(`lastName=${filters.lastName}&`);
        }
        if(filters.userType){
            params=params.concat(`userType=${filters.userType}&`);
        }
        if(filters.dob){
            params=params.concat(`dob=${filters.dob}&`);
        }
        if(filters.enrollmentDate){
            params=params.concat(`enrollmentDate=${filters.enrollmentDate}&`);
        }
    }
    const res = await fetch(`${url}?${params}`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
    });
 
    const result = await res.json();
    return {result, isFilter};
});

//updateUser
export const updateUser = createAsyncThunk(`/user/update`, async (data={}) => {
    const res = await fetch(`${baseUrl}/user`,{
        method:"PUT",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
     });
    const result = await res.json();
    return result;
});

//addNote
export const addNote = createAsyncThunk(`/user/addNote`, async (newNote) => {
    const res = await fetch(`${baseUrl}/user/addNote`,{
        method:"POST",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(newNote)
     });
    const result = await res.json();
    return result
   
});

//createUser
export const createUser = createAsyncThunk(`/user/create`, async (data={}) => {
    const res = await fetch(`${baseUrl}/user/create`,{
        method:"POST",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
     });
    const result = await res.json();
    return result;
});

//Instruction
export const getInstruction = createAsyncThunk('/content/instructions', async () => {
    const data = await fetch(`${baseUrl}/content/instructions`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
    });
    const result = await data.json();
    return result;
});

//Exercise
export const getExercise = createAsyncThunk('/content/exercise', async () => {
    const data = await fetch(`${baseUrl}/content/exercise`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
    });
    const result = await data.json();
    return result;
});

//Education
export const getEducation = createAsyncThunk('/content/education', async () => {
    const data = await fetch(`${baseUrl}/content/education`,{
    method:"POST",
        headers:{
            "authorization": "Bearer 394273c6-08ef-4252-9f18-b97135bf7bc7",
            "Content-Type": "application/json",
        }
    });
    const result = await data.json();
    return result;
});


// Get Questionnaire
export const getQuestionnaireById =  createAsyncThunk('/user/questionnaireById', async (taskId) => {
    const res = await fetch(`${baseUrl}/user/questionnaire?id=${taskId}&page=all`,{
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        }
    });    
    const result = await res.json();
    return result;
});


//Submit Ans
export const submitAnswers = createAsyncThunk('/user/submit', async (postData) => {
    const res = await fetch(`${baseUrl}/user/submit`,{
       method:"PUT",
       headers: {
        "authorization": `${localStorage.getItem('token')}` ,
        "Content-Type": "application/json",
    },
       body: JSON.stringify(postData)
    });

    const result = await res.json();
    return {...result};
});

//Today
export const todaysTasks =  createAsyncThunk('/user/today', async () => {
    const res = await fetch(`${baseUrl}/user/today`,{
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        }
    });
    
    const result = await res.json();
    console.log(result);
    return result;
    //  return questionnaire;
});

//getMedia
export const getMedia =  createAsyncThunk('/getMedia', async (assetId) => {
    const res = await fetch(`${baseUrl}/asset?id=${assetId}`,{
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        }
    });
    
    const result = await res.json();
    return result;
});

//Complete Task
export const completeTask =  createAsyncThunk('/completeTask', async (taskId) => {
    const res = await fetch(`${baseUrl}/user/complete`, {
        method:"POST",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(taskId)
    });
    
    const result = await res.json();
    return result;
});

//user/clinic
export const initialClinic =  createAsyncThunk('/initialClinic', async (request) => {
    const res = await fetch(`${baseUrl}/user/clinic`, {
        method:"POST",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request)
    });
    
    const result = await res.json();
    return result;
});

export const getProgramStats =  createAsyncThunk('/programStats', async (request) => {
    const res = await fetch(`${baseUrl}/programStats`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request)
    });
    
    const result = await res.json();
    return result;
});

export const getPerformance =  createAsyncThunk('/performance', async (userId) => {

    const res = await fetch(`${baseUrl}/user/performance?userId=${userId}`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
    });

    const result = await res.json();
    return result;
});

export const getPrograms = createAsyncThunk('/programs', async () => {
    const res = await fetch(`${baseUrl}/programs`, {
        method:"GET",
        headers: {
            "authorization": `${localStorage.getItem('token')}` ,
            "Content-Type": "application/json",
        },
    });

    const result = await res.json();
    return result;
})